import { useEffect } from "react";

export function usePrintHotkeyListener(handler: () => void)
{
    useEffect(() =>
    {
        const onKeyDown = (e: KeyboardEvent) =>
        {
            console.log("usePrintHotkey onKeyDown: ");

            const isPrint =
                (e.ctrlKey || e.metaKey) && e.key.toLowerCase() === "p";

            console.log("isPrint: ", isPrint);
            if (isPrint) {
                e.preventDefault(); // wird nicht überall zuverlässig respektiert
                handler();
            }
        };

        window.addEventListener("keydown", onKeyDown);

        return () =>
        {
            window.removeEventListener("keydown", onKeyDown);
        };
    }, [handler]);
}


export function setPrintOrientation(orientation: "portrait" | "landscape")
{
    const style = document.createElement("style");

    style.id = "print-style";
    style.innerHTML = `
        @media print {
            @page {
                size: A4 ${orientation} !important;
            }
        }`;

    document.head.appendChild(style);
    return style;
}

export const handlePrint = () =>
{

    const style = setPrintOrientation("portrait");

    window.print();

    style.remove();

};
